import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { Divider } from "@/shared/base/components/Divider/Divider";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import { Box, Grid, Stack, Theme, Typography, useTheme } from "@mui/material";
import React from "react";
import { v4 as uuid } from "uuid";

export function HowItWorks() {
  const theme = useTheme();
  const { howItWorks } = useTeamConfig();

  return (
    <Box>
      <Box>
        <Divider>
          <Box
            bgcolor={theme.palette.background.paper}
            width={"fit-content"}
            pr={4}
          >
            <Typography variant="h6" fontWeight={"700"} color="text.primary">
              How It Works
            </Typography>
          </Box>
        </Divider>
      </Box>
      <Box mt={2}>
        <Grid container>
          {howItWorks.map((itm, idx) => {
            return (
              <Grid key={uuid()} item xs={12}>
                <HowItWorksItem
                  icon={itm.icon}
                  title={itm.title}
                  description={itm.description}
                  idx={idx + 1}
                />
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Box>
  );
}

interface HowItWorksItemProps {
  icon: React.ReactNode;
  title: string | React.ReactNode;
  description: string | React.ReactNode;
  idx: number;
}

function HowItWorksItem({ icon, title, description, idx }: HowItWorksItemProps) {
  const theme = useTheme();
  const styles = useStyles(theme);
  const { md: mdDown } = useCssMediaQuery("down");

  return (
    <Grid sx={styles.howItWorksWrapper} alignItems={"center"}>
      <Box py={3}>
        <Stack direction={"row"} spacing={mdDown ? 2 : 3} alignItems={"center"}>
          <Box>
            <Box sx={styles.howItWorksIcon}>{icon}</Box>
          </Box>
          <Box>
            <Stack>
              <Box>
                <Typography
                  fontSize={"1rem"}
                  fontWeight={600}
                  color="text.primary"
                >
                  {idx}. {title}
                </Typography>
              </Box>
              <Box mt={1}>
                <Typography variant="body2" color="text.secondary">
                  {description}
                </Typography>
              </Box>
            </Stack>
          </Box>
        </Stack>
      </Box>
    </Grid>
  );
}

function useStyles(theme: Theme) {
  return {
    howItWorksWrapper: {
      borderBottom: `1px solid ${theme.palette.divider} !important`,
      "&:last-child": {
        borderBottom: "none",
      },
    },
    howItWorksIcon: {
      width: "80px",
      height: "80px",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      fontSize: "2rem",
      [theme.breakpoints.down("sm")]: {
        width: "48px",
        height: "48px",
        fontSize: "1.5rem",
      },
    },
  };
}
